// Paleta NULED — extraída de nuled.mx (storefront actual de BigCommerce).
// Verde petróleo + amarillo lima sobre body blanco.
// Compartida con todo el frontend. Usar inline styles, NO Tailwind.

export const theme = {
  // Body
  bg:          '#FFFFFF',
  bgSoft:      '#F7F7F7',
  bgFooter:    '#FBFCF4',  // off-white amarillento — footer
  bgImage:     '#F4F5F5',  // fondo placeholder de imagen de producto

  // Verde petróleo NULED — color oficial de la marca
  brand:       '#2D484F',
  brandDark:   '#1F343A',
  brandLight:  '#4A6770',

  // Amarillo lima — CTAs y separadores
  accent:      '#CCCC33',
  accentDark:  '#A8A82A',
  accentSoft:  '#F0F0BD',

  // Texto
  text:        '#2D484F',  // sobre fondo blanco usamos brand verde petróleo
  textOnBrand: '#FFFFFF',
  textMuted:   '#6B7B7F',
  textDim:     '#9CA8AB',

  // Estados
  ok:          '#10B981',
  warn:        '#F59E0B',
  err:         '#DC2626',
  info:        '#0E7490',

  // Marcas (productos)
  brandTag: {
    nuled:  '#2D484F',
    lutron: '#5A4A8A',
  },

  // Estructura
  border:      '#EDEDED',
  borderStrong:'#D1D5D6',
  divider:     '#CCCC33',  // 5px solid en top de footer

  radius: {
    sm: 2,
    md: 4,
    lg: 8,
    pill: 999,
  },

  font: {
    sans:  "Roboto, Arial, Helvetica, sans-serif",
    head:  "Montserrat, Arial, Helvetica, sans-serif",
    mono:  "ui-monospace, SFMono-Regular, Menlo, monospace",
  },

  // Spacings (4px base)
  space: (n: number) => n * 4,

  // Shadow
  shadow: {
    card:   '0 1px 3px rgba(0,0,0,0.04)',
    raised: '0 4px 12px rgba(45,72,79,0.08)',
  },

  // Layout
  maxWidth: 1280,
} as const;

export type Theme = typeof theme;
